// extracted by mini-css-extract-plugin
export default {"formItem":"Ws1BpD1rssac2PXZ4dZn"};